import { useEffect } from "react";
import { eventPaymentSuccess } from "../utilities/dataLayer";
import { PayPalAndApplePayPurchase } from "../utilities/facebookPixel";

const useHandleApplePayUpdate = (isClientSide) => {
  // When the user completes the payment these field values should be posted.
  useEffect(
    function onLoad() {
      if (!isClientSide) return;
      const query = new URLSearchParams(window.location.search);
      const action = query.get("action");
      const paymentIntentId = query.get("paymentIntentId");
      const transactionId = query.get("transactionId");
      if (action === "applepaysucces" && transactionId) {
        eventPaymentSuccess(paymentIntentId);
        PayPalAndApplePayPurchase(transactionId);
      }
    },
    [isClientSide]
  );
};

export default useHandleApplePayUpdate;
